import React, { FC, memo } from 'react';
import { Wrapper, Title, Item, Empty } from './components';
import Point from './components/Point';
import { Category, PointData } from 'src/api/types';

interface PointDataExtend extends PointData {
    _hidden?: boolean;
}

interface TemplateProps {
    category?: Category;
    chosenId?: number;
    onChoose?: (id?: number) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { category, chosenId, onChoose } = props;

    return (
        <>
            {category?.children?.map((leafCategory) => (
                <Wrapper>
                    <Title>{leafCategory?.name}</Title>

                    {(leafCategory?.pointDataList?.length ?? 0) > 0 ? (
                        <Item>
                            {leafCategory?.pointDataList?.map((inspectPoint) =>
                                !(inspectPoint as PointDataExtend)._hidden ? (
                                    <Point
                                        inspectPoint={inspectPoint}
                                        isChosen={chosenId === inspectPoint.pointId}
                                        onChoose={() => onChoose?.(inspectPoint.pointId)}
                                    />
                                ) : null
                            )}
                        </Item>
                    ) : (
                        <Empty>暂无数据</Empty>
                    )}
                </Wrapper>
            ))}
        </>
    );
});

export default Template;
